import React, { useState } from "react";

interface SidebarProps {
  children?: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Hamburger for mobile and md screens only (hidden on lg+) */}
      <button
        className="fixed top-4 left-4 z-50 bg-white border border-gray-200 text-gray-700 p-3 rounded-lg shadow-sm focus:outline-none block lg:hidden hover:bg-gray-50 transition-all duration-200"
        onClick={() => setOpen((v) => !v)}
        aria-label="Toggle sidebar"
      >
        <svg
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static top-0 left-0 h-screen bg-white border-r border-gray-200 text-gray-900 flex flex-col z-40 shadow-sm overflow-hidden
          transition-all duration-300 ease-in-out
          ${open ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
        style={{
          width: "var(--sidebar-width)",
        }}
      >
        <div className="flex-1 overflow-y-auto py-6 flex flex-col items-center">
          {children}
        </div>
      </aside>

      {/* Overlay for mobile and md screens when sidebar is open (hidden on lg+) */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 block lg:hidden backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
